module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAtElEQVR4AWMYHCCVgeE/AzkYBs4AOamUGgA2hBIDYPhZY+N/dPBuxYr/T6qq/v+4efP/vz9/4OKYBiAMQdF8jpPz/4979/5/OXny/8ft2/EZgMBPq6vBih5mZv6/oq7+//vVq/8vKyr+vyghATIIvwFP6+rgtrzfuPH/WWbm/z9u3wYb+qSiAuYNhAHomtHBx127/j8uK/v/4+5dEBe3F9LtgSHbQAKGAYRmMg2AaCYDDw8AAPcZP4qAg9+sAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/EH.png
// module id = 1131
// module chunks = 0